module.exports = __webpack_public_path__ + "assets/tDbK2oqRg1oM3QBjjcaDkOr4nAfcHg-53a61d.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/tDbK2oqRg1oM3QBjjcaDkOr4nAfcHg.woff2
// module id = 861
// module chunks = 2